import { emptyObj } from 'util/objects'

// eslint-disable-next-line no-underscore-dangle
export const _selectById = state => state.mailboxes.byId || emptyObj
